import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Cart"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-cart',
    templateUrl: './icon-cart.component.html',
    styleUrls: ['./icon-cart.component.scss'],
    standalone: false
})
export class IconCartComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
